import PropTypes from 'prop-types'
import { MenuItem, Select } from '@mui/material'
import { KeyboardArrowDown } from '@mui/icons-material'

import { OPEN_TO_REQUESTS_OPTIONS } from './helpers'
import { useTranslation } from 'react-i18next'

const OpenToRequestsSelect = ({ value, onChange }) => {
  const { i18n } = useTranslation()
  const t = i18n.getResourceBundle(i18n.language)
  const items = OPEN_TO_REQUESTS_OPTIONS({ t })

  return (
    <div className="Search-page__filters-requests-wrapper">
      <span>{t.search.openRequests}</span>
      <Select
        className="Search-page__filters-requests"
        value={value}
        IconComponent={KeyboardArrowDown}
        MenuProps={{ className: 'Search-page__filters-requests-menu' }}
        onChange={onChange}
      >
        {items.map(({ value, label }, index) => {
          const lastClass = index + 1 === items.length ? 'last' : ''

          return (
            <MenuItem
              key={index}
              className={`Search-page__filters-menu-item ${lastClass}`}
              value={value}
            >
              {label}
            </MenuItem>
          )
        })}
      </Select>
    </div>
  )
}

OpenToRequestsSelect.propTypes = {
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired
}

export default OpenToRequestsSelect
